import { createGtm } from '@gtm-support/vue-gtm'
import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query'
import { createApp } from 'vue'
import { Router } from 'vue-router'
import { createVuestic } from 'vuestic-ui'

import { default as adminNavRoutes } from '../admin/components/NavigationRoutes'
import { default as adminNames } from '../admin/components/get-display-name'
import { default as adminRoutes } from '../admin/router/routes'
import { default as customerNavRoutes } from '../customer/components/NavigationRoutes'
import { default as customerNames } from '../customer/components/get-display-name'
import { default as customerRoutes } from '../customer/router/routes'
import { default as devNavRoutes } from '../tenant/components/NavigationRoutes'
import { default as devNames } from '../tenant/components/get-display-name'
import { default as devRoutes } from '../tenant/router/routes'
import App from './App.vue'
import i18n from './i18n'
import { makeRouter } from './router'
import { vPermission, vPermissionDisabled } from './services/permission/vPermission'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import stores from './stores'
import { useUserStore } from './stores/user-store'

const app = createApp(App)

let router = {} as Router

switch (import.meta.env.MODE) {
  case 'Tenant':
    router = makeRouter(devRoutes)
    app.provide('routes', devRoutes)
    app.provide('get-display-name', devNames)
    app.provide('nav-routes', devNavRoutes)
    break
  case 'Admin':
    router = makeRouter(adminRoutes)
    app.provide('routes', adminRoutes)
    app.provide('get-display-name', adminNames)
    app.provide('nav-routes', adminNavRoutes)
    break
  case 'Customer':
    router = makeRouter(customerRoutes)
    app.provide('routes', customerRoutes)
    app.provide('get-display-name', customerNames)
    app.provide('nav-routes', customerNavRoutes)
    break
  default:
    throw new Error('Invalid frontend!')
}

app.use(stores)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
    }),
  )
}

// Configure Vue Query globally
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        cacheTime: 1000 * 60 * 30, // 30 minutes
        refetchOnWindowFocus: false,
        retry: 3, // Number of retry attempts
      },
      mutations: {
        // Global mutation configuration
        suspense: true,
        retry: 1, // Number of retry attempts for mutations
      },
    },
  },
} as VueQueryPluginOptions)

// Register permission directives
app.directive('permission', vPermission)
app.directive('permission-disabled', vPermissionDisabled)

useUserStore()
  .init()
  .then(() => {
    app.use(router)
    app.provide('router', router)
    app.mount('#app')
  })
